/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{DataType as N}from"../../../../webgl/enums.js";const T={[N.BYTE]:1,[N.UNSIGNED_BYTE]:1,[N.SHORT]:2,[N.UNSIGNED_SHORT]:2,[N.HALF_FLOAT]:2,[N.INT]:4,[N.UNSIGNED_INT]:4,[N.FLOAT]:4};export{T as dataSizeInBytes};
